import PriceCard from "../../components/PriceCard";
import heroBanner from "@/assets/images/pages/4-hour-drug-alcohol.png";

const FourHourDrugAlcohol = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">
                4 Hour Florida Drug and Alcohol Course
              </h1>
              <p className="banner-subheading">State of Florida Certified</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="p-4"
                style={{ backgroundColor: "#252525", borderRadius: "8px" }}
              >
                <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                  Course Details
                </h3>

                <p className="text-white mb-4 fs-5">
                  The Florida Drug and Alcohol Course, is a state mandated (4)
                  hour new driver orientation course. To be eligible for a
                  Driving Permit or Florida Driver License, ALL persons who will
                  be new drivers (permit license) such as students, or those who
                  have never possessed a Drivers License in any other state or
                  foreign country MUST complete this course or it's equivalent.
                </p>

                <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                  At Metro Traffic school, our New Driver Drug and Alcohol
                  program takes pride in
                </h3>

                <ul className="text-white mb-4">
                  <li className="mb-3">
                    Teaching our students to understand how alcohol and other
                    drugs will affect their driving and life in general
                  </li>
                  <li className="mb-3">
                    Teaching our students to understand the responsibility
                    involved, and laws governing, the operation of any motor
                    vehicle in the State of Florida
                  </li>
                  <li className="mb-3">
                    Teaching our students methods to better understand and use
                    safe driving techniques
                  </li>
                  <li className="mb-3">
                    Teaching our students methods to increase driver & passenger
                    awareness on our roadways
                  </li>
                </ul>

                <div
                  className="p-3 mb-4"
                  style={{
                    backgroundColor: "#252525",
                    border: "1px solid var(--metro-yellow)",
                  }}
                >
                  <p className="text-white mb-0">
                    The effect of the 4-Hour New Driver Drug and Alcohol course
                    on future drivers of any age is critical. We stand firm in
                    our commitment to provide each student with the knowledge &
                    tools necessary to avoid becoming a part of tomorrow's often
                    tragic headline.
                  </p>
                </div>

                <div className="row g-0 mb-4">
                  <div
                    className="p-0"
                    style={{
                      backgroundColor: "#252525",
                    }}
                  >
                    <p className="text-white mb-0">
                      Upon successful completion of the Florida 4-Hour Drug and
                      Alcohol class (Live or Online), each student will receive
                      a certificate of completion thereby meeting State of
                      Florida Requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row g-3 justify-content-center">
                <PriceCard
                  iconClass="fas fa-chalkboard-teacher fa-2x"
                  title="Classroom Course"
                  price="$19.95"
                  buttonText="Register for Classroom Course"
                  buttonLink="https://classroom.metrotrafficschool.com/create-account/OA=="
                  buttonProps={{
                    className:
                      "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary metro-btn-pulse",
                  }}
                />
                <PriceCard
                  iconClass="fas fa-laptop fa-2x"
                  title="Online Course"
                  price="$19.95"
                  buttonText="Register for Online Course"
                  buttonLink="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg0"
                  buttonProps={{
                    className:
                      "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-secondary",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FourHourDrugAlcohol;
